const parkingConfig = {
  state: {
    parkingLocation: {
      longitude: '',
      latitude: '',
      address: ''
    }
  },

  mutations: {
    SET_PARKING_LOCATION: (state, data) => {
      state.parkingLocation = data
    }

  },

  actions: {
    // 获取停车场经纬度
    getParkingLocation({ commit }, data) {
      commit('SET_PARKING_LOCATION', data)
    }

  },
  getters: {
    getParkingLocation: state => state.parkingLocation
  }
}

export default parkingConfig
